import React from 'react';
import {view} from 'react-easy-state';
import Store from './store/store';
import PrestBlock from './components/PrestBlock';
import DatiBlock from './components/DatiBlock';
import {withTranslation} from 'react-i18next';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-20%',
    transform: 'translate(-50%, -50%)',
  },
};

class App extends React.Component {
  render () {
    const {t} = this.props;
    const {
      isSent,
      prestazioni,
      _prestazioni4elenco,
      isElencoPrestOpen,
      reset,
      disdettaEmail,
      isModalOpen,
      closeModal,
      modalContent,
    } = Store;

    function getIsNuclear () {
      let isNuclear = false;

      const popupValueAsBoolean = popupRawValue => {
        if (typeof popupRawValue === 'undefined') return false;
        if (popupRawValue === null) return false;
        if (popupRawValue === false) return false;
        if (Array.isArray (popupRawValue) && popupRawValue.length === 0)
          return false;

        console.log ('isnuke', popupRawValue);
        return true;
      };

      for (const p of prestazioni) {
        if (popupValueAsBoolean (p.get ('popup')) === true) {
          isNuclear = true;
        }
      }

      console.log ('getIsNuclear--->', isNuclear);

      return isNuclear;
    }

    Modal.setAppElement ('#gemelli-prenota-app');
    //Modal.setAppElement('#top');

    return (
      <div className="App kfpr-main">
        <Modal
          style={customStyles}
          isOpen={isModalOpen}
          contentLabel="Test Label"
        >
          <div className="kfpr-modal">
            <div>
              <div
                className="kfpr-modal-content"
                dangerouslySetInnerHTML={{__html: modalContent}}
              />
              <div className="kfpr-modal-close" onClick={closeModal}>
                HO CAPITO
              </div>
            </div>
          </div>
        </Modal>

        <div className="kfpr-prest-elenco">
          {isElencoPrestOpen &&
            _prestazioni4elenco.map ((prestName, i) => (
              <div className="kfpr-prest-elenco-item" key={i}>{prestName}</div>
            ))}
        </div>
        {isSent &&
          <div className="kfpr-box kfpr-box-message kfpr-box-message-thankyou">
            <div className="kfpr-box-inner">
              <div className="kfpr-cont">
                <div className="kfpr-row kfpr-row-head">
                  <strong>{t ('Grazie')}!</strong>
                  <img
                    src="/wp-content/uploads/2019/06/kfpr-ico-message-ok.png"
                    alt=""
                  />
                </div>
                <div className="kfpr-row">
                  <p>
                    {getIsNuclear () === false &&
                      <span>
                        <br />
                        {t (
                          'La tua richiesta di prenotazione è stata ricevuta correttamente, un operatore del CUP (Centro Unico Prenotazioni) ti ricontatterà quanto prima'
                        )}
                        .
                      </span>}
                    {getIsNuclear () === true &&
                      <span>
                        <br />
                        {t (
                          'La tua richiesta di prenotazione è stata ricevuta correttamente, un operatore ti ricontatterà quanto prima'
                        )}
                        .
                      </span>}
                  </p>
                  <div>
                    <strong>
                      {t (
                        'Scarica se disponibili i documenti informativi in pdf riguardanti la prestazione scelta'
                      )}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        {prestazioni.map ((prest, i) => <PrestBlock idx={i} key={i} />)}

        {!isSent && <DatiBlock />}

        {isSent &&
          <div className="kfpr-box kfpr-box-message kfpr-box-message-white">
            <div className="kfpr-box-inner">
              <div className="kfpr-cont">
                <div className="kfpr-row kfpr-row-head">
                  <strong>{t ('Nota Bene')}:</strong>
                </div>
                <div className="kfpr-row">
                  <p>
                    {t (
                      'Questo messaggio è solo una notifica di avvenuta ricezione, non è in nessun modo da considerare come una prenotazione avvenuta'
                    )}
                    .
                    {' '}
                  </p>
                  <div>
                    <strong>
                      {getIsNuclear () === false &&
                        <span>
                          {t (
                            'La prenotazione sarà realmente effettiva solo dopo la ricezione della chiamata da parte del CUP'
                          )}
                          <br />
                          {' '}
                          (
                          {t ('Centro Unico Prenotazioni')}
                          )
                        </span>}
                      {getIsNuclear () === true &&
                        <span>
                          {t (
                            "La prenotazione sarà realmente effettiva solo dopo la ricezione della chiamata da parte dell'operatore"
                          )}
                        </span>}

                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        {isSent &&
          <div className="kfpr-row kfpr-row-final-info">
            <h2>{t ('Alcune note')}</h2>

            {getIsNuclear () === false &&
              <p>
                {t (
                  "Potrà capitare che la chiamata da parte dell'operatore del CUP (Centro Unico Prenotazioni) risulti arrivare da un"
                )}
                {' '}
                <strong>{t ('numero privato')}</strong>
                {' '}
                o
                {' '}
                <strong>{t ('nascosto')}</strong>
                ,
                {' '}
                {t ('assicurati di rispondere ugualmente')}
                .
              </p>}
            {getIsNuclear () === true &&
              <p>
                {t (
                  "Potrà capitare che la chiamata da parte dell'operatore risulti arrivare da un"
                )}
                {' '}
                <strong>{t ('numero privato')}</strong>
                {' '}
                o
                {' '}
                <strong>{t ('nascosto')}</strong>
                ,
                {' '}
                {t ('assicurati di rispondere ugualmente')}
                .
              </p>}

            <p>
              {t (
                'Ricordati di disdire la tua prenotazione per tempo se fossi impossibilitato'
              )}
              .
              {' '}
              {disdettaEmail ().includes ('G') &&
                getIsNuclear () === false &&
                <span>
                  <br />
                  {t (
                    "Per disdire una prestazione presso il Policlinico Gemelli puoi scrivere un'email all'indirizzo"
                  )}
                  {' '}
                  <a
                    className="kf-link italic no-underline"
                    href="mailto:disdettecup@policlinicogemelli.it"
                  >
                    disdettecup@policlinicogemelli.it
                  </a>
                  ,
                  {' '}
                  {t ('chiamare il CUP al numero')}
                  {' '}
                  <a
                    className="kf-link normal no-underline"
                    href="tel:+390688505560"
                  >
                    06 8880.5560
                  </a>
                  {' '}
                  (
                  {t ('premere il tasto 1 per parlare con un operatore')}
                  ),
                  {' '}
                  {t ('o inviare un fax al numero')}
                  {' '}
                  <strong>06 3015.5428</strong>
                </span>}
              {disdettaEmail ().includes ('C') &&
                getIsNuclear () === false &&
                <span>
                  <br />
                  {t (
                    "Per disdire una prestazione presso il Presidio Columbus puoi scrivere un'email all'indirizzo"
                  )}
                  {' '}
                  <a
                    className="kf-link italic no-underline"
                    href="mailto:disdette.columbus@policlinicogemelli.it"
                  >
                    disdette.columbus@policlinicogemelli.it
                  </a>
                  {' '}
                  o
                  {' '}
                  {t ('chiamare il CUP al numero')}
                  {' '}
                  <a
                    className="kf-link normal no-underline"
                    href="tel:+390688805560"
                  >
                    06 8880.5560
                  </a>
                  {' '}
                  (
                  {t ('premere il tasto 2 per parlare con un operatore')}
                  )
                </span>}

              {getIsNuclear () === true &&
                <span>
                  <br />
                  {t (
                    "Per disdire una prestazione presso il Policlinico Gemelli puoi scrivere un'email all'indirizzo"
                  )}
                  {' '}
                  <a
                    className="kf-link italic no-underline"
                    href="mailto:prenotazionescintigrafia@policlinicogemelli.it"
                  >
                    prenotazionescintigrafia@policlinicogemelli.it
                  </a>
                  .
                </span>}
            </p>
          </div>}

        {isSent &&
          <div className="button big" role="button" onClick={reset}>
            {t ('Inserisci una nuova richiesta')}
          </div>}
      </div>
    );
  }
}

export default withTranslation () (view (App));
